export const changeMain_en = {
    load: 'Update',
    positiveResponse: 'Your profile is updated',
    positiveResponsePassword: 'Your password has been successfully changed',
    yourNewPassword: 'New password:',
    negativeResponse: 'Something went wrong',
    repeatRequest: 'Most likely, the changes in your data have already been saved',
    linkMainPage: 'Home page',
}